import React from 'react';
import {Provider} from 'react-redux';
import store from './redux/store';
import {Route, Router, Switch} from 'react-router-dom';
import Views from './views';
import {ThemeSwitcherProvider} from 'react-css-theme-switcher';
import {THEME_CONFIG} from './configs/AppConfig';
import history from './history';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // In this case we can log this error to the server
    this.props.history.push(`/error`);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

function App() {
  const checkVersion = async () => {
    const response = await fetch(process.env.REACT_APP_APP_URL + 'version.txt');
    const version = await response.text();
    const loadedVersion = localStorage.getItem('version');
    console.log('Current version is ' + version + ' and loaded version is ' + loadedVersion);

    if (loadedVersion !== version) {
      console.log('Not running the latest version. Reloading...');
      localStorage.clear();
      window.location.reload(true);
      localStorage.setItem('version', version);
    } else {
      console.log('App is running the latest version');
    }
  };

  checkVersion();

  return (
    <div className="App">
      <ErrorBoundary history={history}>
        <Provider store={store}>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <Router history={history}>
              <Switch>
                <Route path="/" component={Views} />
              </Switch>
            </Router>
          </ThemeSwitcherProvider>
        </Provider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
